import { Directive, Inject, OnInit } from '@angular/core';
import { SurveyStep, SurveyResponse } from '@nx-c4g/c4g-models';

@Directive()
export class BaseSurveyStepComponent implements OnInit {
  stepData: SurveyStep;
  protected initialStepResponse?: SurveyResponse;

  constructor(
    @Inject('stepData') protected injectedStepData: SurveyStep,
    @Inject('stepResponse') protected stepResponseFn: (response: SurveyResponse) => void,
    @Inject('initialStepResponse') initialStepResponse?: SurveyResponse
  ) {
    this.initialStepResponse = initialStepResponse;
  }

  ngOnInit() {
    this.stepData = this.injectedStepData;
  }

  protected emitResponse(response: SurveyResponse) {
    this.stepResponseFn(response);
  }

  // Abstract method to be implemented by child components
  async getResponse(): Promise<SurveyResponse | undefined> {
    return undefined;
  }

  // Abstract method for validation
  isValid(): boolean {
    return true;
  }
}
